import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/forgot',
    name: '忘记密码',
    component: () => import('../views/Login/Forget.vue'),
    // 设置头部
    meta: {
      isShow: false,
      isTitleShow: true,
      keepAlive: false
    }
  },
  {
    path: '/registered',
    name: '注册账号',
    component: () => import('../views/Login/Registered.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true

    }
  },
  {
    path: '/login',
    name: '登录',
    component: () => import('../views/Login/Login.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/home',
    name: '主页',
    component: () => import('../views/Home/Home.vue'),
    meta: {
      keepAlive: true,
      isShow: true,
      isTitleShow: false

    }
  },
  {
    path: '/commodityDetail/id/:id',
    name: '商品详情',
    component: () => import('../views/Details/CommodityDetail.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/classification',
    name: '商品分类',
    component: () => import('../views/Classification/Classification.vue'),
    meta: {
      keepAlive: true,
      isShow: true,
      // 标题
      isTitleShow: true
    }
  },
  {
    path: '/article',
    name: '文章',
    component: () => import('../views/Article/Article.vue'),
    meta: {
      keepAlive: true,
      isShow: true,
      // 标题
      isTitleShow: true
    }
  },
  {
    path: '/order',
    name: '订单',
    component: () => import('../views/Order/Order.vue'),
    meta: {
      keepAlive: true,
      isShow: true,
      isTitleShow: true
    }
  },
  {
    path: '/makeSureTheOrder',
    name: '确认订单',
    component: () => import('../views/Order/MakeSureTheOrder.vue'),
    meta: {
      keepAlive: false,
      isTitleShow: true
    }
  },
  {
    path: '/shippingAddress',
    name: '收货地址',
    component: () => import('../views/Address/ShippingAddress.vue'),
    meta: {
      keepAlive: false,
      isTitleShow: true
    }
  },
  {
    path: '/newAddress',
    name: '添加地址',
    component: () => import('../views/Address/NewAddress.vue'),
    meta: {
      keepAlive: false,
      isTitleShow: true
    }
  },
  {
    path: '/editAddress',
    name: '编辑地址',
    component: () => import('../views/Address/EditAddress.vue'),
    meta: {
      keepAlive: false,
      isTitleShow: true
    }
  },
  {
    path: '/pay',
    name: '在线支付',
    component: () => import('../views/Pay/Pay.vue'),
    meta: {
      keepAlive: false,
      isTitleShow: true
    }
  },
  {
    path: '/personal',
    name: '个人中心',
    component: () => import('../views/Personal/Personal.vue'),
    meta: {
      keepAlive: true,
      isShow: true,
      isTitleShow: false
    }
  },
  {
    path: '/personalData',
    name: '个人资料',
    component: () => import('../views/Personal/PersonalData.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/statistics',
    name: '数据统计',
    component: () => import('../views/Personal/Statistics.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/paySuccess',
    name: '支付成功',
    component: () => import('../views/Pay/PaySuccess.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/welfare',
    name: '积分商城',
    component: () => import('../views/Welfare/Welfare.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/forRecord',
    name: '兑换记录',
    component: () => import('../views/Welfare/ForRecord.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/recordDetail',
    name: '积分兑换商品详情',
    component: () => import('../views/Welfare/RecordDetail.vue'),
    meta: {
      keepAlive: true,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/integralWater',
    name: '积分流水',
    component: () => import('../views/Welfare/IntegralWater.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/integralDetail',
    name: '积分详情',
    component: () => import('../views/Personal/IntegralDetails.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/awarding',
    name: '积分奖励',
    component: () => import('../views/Personal/Awarding.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/collection',
    name: '我的收藏',
    component: () => import('../views/Collection/Collection.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/myFriends',
    name: '我的好友',
    component: () => import('../views/Personal/Myfriends.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/invitation',
    name: '邀请海报',
    component: () => import('../views/Invitation/Invitation.vue'),
    meta: {
      keepAlive: true,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/myInventory',
    name: '我的库存',
    component: () => import('../views/Inventory/MyInventory.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/inventoryDetail',
    name: '库存明细',
    component: () => import('../views/Inventory/InventoryDetail.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/AddShop',
    name: '补货',
    component: () => import('../views/Inventory/AddShop.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/yunCang',
    name: '云仓配货',
    component: () => import('../views/Inventory/YunCang.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },
  {
    path: '/offLine',
    name: '提货到线下',
    component: () => import('../views/Inventory/OffLine.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  },

  {
    path: '/link/id/:id',
    name: '文章详情',
    component: () => import('../views/Details/Link.vue'),
    meta: {
      keepAlive: false,
      isShow: false,
      isTitleShow: true
    }
  }

]

const router = new VueRouter({
  // mode:'history',
  base: process.env.BASE_URL,
  routes
})

export default router
